<template>
    <div 
        class="queue-task-row" 
        :class="{ 'is-dragging': isDragging }"
        @click.stop.prevent="openInNewTab(Taskdata)"
    >
        <div class="queue-taskname">
            <div class="queue-taskname-item">
                <div class="queue-drag-handle">
                    <div class="drag-btn p-3xs">
                        <img :src="dragIcon" alt="drag" style="width: 16px; height: 16px;"/>
                    </div>
                </div>
                
                <div class="queue-tasktitle">
                    <div class="queue-squaretag">
                        <div 
                            class="queue-status-dot"
                            :style="{ backgroundColor: statusColor }"
                        ></div>
                    </div>
                    <span class="queue-task-text font-size-12" :title="Taskdata.TaskName">
                        {{ Taskdata.TaskName }}
                    </span>
                </div>
            </div>

            <div class="queue-close-container">
                <button class="queue-close-btn" @click.stop="removeFromQueueList(Taskdata)" title="Remove from queue">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 3L3 9M3 3L9 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
            </div>
        </div>

        <div class="queue-table-item">
            <div class="priority-badge" :class="priorityClass">
                <div class="priority-icon-wrapper">
                    <!-- <svg class="priority-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect v-if="priorityKey <= 2" x="3" y="3" width="10" height="2.5" rx="1" fill="currentColor"/>
                        <rect v-if="priorityKey <= 2" x="3" y="6.75" width="10" height="2.5" rx="1" fill="currentColor"/>
                        <rect v-if="priorityKey <= 2" x="3" y="10.5" width="10" height="2.5" rx="1" fill="currentColor"/>
                        <rect v-if="priorityKey === 3" x="3" y="4.5" width="10" height="2.5" rx="1" fill="currentColor"/>
                        <rect v-if="priorityKey === 3" x="3" y="9" width="10" height="2.5" rx="1" fill="currentColor"/>
                        <rect v-if="priorityKey === 4" x="3" y="6.75" width="10" height="2.5" rx="1" fill="currentColor"/>
                    </svg> -->

                    <Priority :priorityVal="Taskdata.Task_Priority" />
                </div>
                <span class="priority-text">{{ priorityLabel }}</span>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, ref, defineProps, defineEmits } from "vue";
import { useStore } from 'vuex';
import Priority from "@/components/molecules/PriorityCompo/PriorityComp.vue"

const dragIcon = require("@/assets/images/svg/drag_icon.svg");

const { getters } = useStore();

const emit = defineEmits(['removeTaskFromQueueData', 'openTaskDetailSidebar']);

const TaskStatusArray = computed(() => getters["settings/AllTaskStatus"]);
const allTaskStatusArray = ref(JSON.parse(JSON.stringify(TaskStatusArray.value)));

const props = defineProps({
    Taskdata: { type: Object, required: true },
    isDragging: { type: Boolean, default: false }
});

const statusColor = computed(() => {
    
    if (allTaskStatusArray.value?.settings?.length) {
        const status = allTaskStatusArray.value.settings.find(
            (ut) => ut.key === props.Taskdata.statusKey
        );
        return status?.textColor || '#FF8D28';
    }
    return '#FF8D28';
});

// Priority
const priorityKey = computed(() => props.Taskdata.Task_Priority);

const priorityConfig = computed(() => {
    const configs = {
        'HIGH': { label: 'Urgent', class: 'red-500' },
        'MEDIUM': { label: 'Medium', class: 'orange-500' },
        'LOW': { label: 'Low', class: 'green-500' },
    };
    return configs[priorityKey.value];
});

const priorityLabel = computed(() => priorityConfig.value.label);
const priorityClass = computed(() => priorityConfig.value.class);

const openInNewTab = (task) => emit('openTaskDetailSidebar', task);
const removeFromQueueList = (obj) => emit('removeTaskFromQueueData', obj);
</script>

<style scoped>
@import '../css/single-queue-list-style.css';
</style>